import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Button from 'src/common/components/ButtonDS22';
import ButtonGroup from 'src/common/components/ButtonGroup';
import Modal from 'src/common/components/Modal';
import styles from 'src/admin/common/styles/BaseModal.module.scss';

type Props = {
  open: boolean;
  closeModal: () => void;
  handleUnsnooze: () => void;
};
const PublishAndUnsnoozeModal: FC<Props> = ({
  open, closeModal, handleUnsnooze,
}) => {
  const [t] = useTranslation('admin-listings');
  return (
    <Modal
      modalOpen={open}
      closeModal={closeModal}
      label={t('landing-page--publish-and-unsnooze-listing-title')}
      className={styles.root}
      preventScroll
    >
      <Modal.Header>
        <Modal.Title>
          {t('landing-page--publish-and-unsnooze-listing-title')}
        </Modal.Title>
        <Modal.Description>
          {t('landing-page--publish-and-unsnooze-listing-subtitle')}
        </Modal.Description>
      </Modal.Header>
      <Modal.Footer>
        <ButtonGroup classNameModifier="centered">
          <Button variant="secondary" onClick={closeModal}>{t('landing-page--cancel')}</Button>
          <Button onClick={handleUnsnooze}>
            {t('landing-page--publish-and-unsnooze')}
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default PublishAndUnsnoozeModal;
